
import React, { useEffect } from 'react';
import './LandingScreen.css';
import logoImage from '../assets/logo.png';
import loaderBg from '../assets/start_bg.jpg';
import loader_bg1 from '../assets/loader_bg1.png';
import loader_bg2 from '../assets/loader_bg2.png';
import loader_bg3 from '../assets/loader_bg3.png';
import loader_bg4 from '../assets/loader_bg4.png';
import loader_bg5 from '../assets/loader_bg5.png';
import loader_bg6 from '../assets/loader_bg6.png';
import loader_bg7 from '../assets/loader_bg7.png';
import { UserQueueData, LastTicketData } from '../types';

type LandingScreenProps = {
    onContinue: () => void;
    onUserDataLoaded: (data: UserQueueData | null) => void;
    onLastTicketLoaded: (lastTicket: number | null) => void;
};

function getUserIdFromQuery(): string | null {
    if (typeof window === 'undefined') return null;
    const params = new URLSearchParams(window.location.search);
    return params.get('userid');
}

export const LandingScreen: React.FC<LandingScreenProps> = ({
                                                                onContinue,
                                                                onUserDataLoaded,
                                                                onLastTicketLoaded,
                                                            }) => {
    useEffect(() => {
        let timeoutId: number | null = null;

        const startTimer = () => {
            timeoutId = window.setTimeout(onContinue, 5300);
        };

        const fetchLastTicket = async () => {
            try {
                const res = await fetch('https://zhduliapi.flami-dev.ru/last-ticket');
                if (!res.ok) {
                    console.error('Ошибка GET /last-ticket', res.status);
                    onLastTicketLoaded(null);
                    return;
                }
                const data: LastTicketData = await res.json();
                onLastTicketLoaded(data.last_ticket_in_system);
            } catch (e) {
                console.error('Ошибка GET /last-ticket', e);
                onLastTicketLoaded(null);
            }
        };

        const fetchUserOrLastTicket = async () => {
            const userid = getUserIdFromQuery();

            if (!userid) {
                onUserDataLoaded(null);
                await fetchLastTicket();
                startTimer();
                return;
            }

            try {
                const res = await fetch(
                    `https://zhduliapi.flami-dev.ru/users/${userid}`
                );
                if (res.status === 404) {
                    onUserDataLoaded(null);
                    await fetchLastTicket();
                } else if (res.ok) {
                    const data: UserQueueData = await res.json();
                    onUserDataLoaded(data);
                    onLastTicketLoaded(data.ticket);
                } else {
                    console.error('Ошибка GET /users/{userid}', res.status);
                    onUserDataLoaded(null);
                    await fetchLastTicket();
                }
            } catch (e) {
                console.error('Ошибка GET /users/{userid}', e);
                onUserDataLoaded(null);
                await fetchLastTicket();
            } finally {
                startTimer();
            }
        };

        fetchUserOrLastTicket();

        return () => {
            if (timeoutId !== null) {
                window.clearTimeout(timeoutId);
            }
        };
    }, []);

    return (
        <div className="LandingScreen">
            <div className="LandingScreenBg" style={{ backgroundImage: 'url(' + loaderBg + ')' }}></div>
            <div className="LandingScreen-bubbles">
                <div className="LandingScreen-bubble" style={{ backgroundImage: 'url(' + loader_bg7 + ')' }}></div>
                <div className="LandingScreen-bubble" style={{ backgroundImage: 'url(' + loader_bg6 + ')' }}></div>
                <div className="LandingScreen-bubble" style={{ backgroundImage: 'url(' + loader_bg5 + ')' }}></div>
                <div className="LandingScreen-bubble" style={{ backgroundImage: 'url(' + loader_bg4 + ')' }}></div>
                <div className="LandingScreen-bubble" style={{ backgroundImage: 'url(' + loader_bg3 + ')' }}></div>
                <div className="LandingScreen-bubble" style={{ backgroundImage: 'url(' + loader_bg2 + ')' }}></div>
                <div className="LandingScreen-bubble" style={{ backgroundImage: 'url(' + loader_bg1 + ')' }}></div>
            </div>
            <div className="LandingScreen-content">
                <div className="LandingScreen-logo">
                    <img src={logoImage} alt="Логотип" className="LandingScreen-logoImage"/>
                </div>
            </div>
        </div>
    );
};
